<div id="existing-client" data-cy="existing-client">
  <div class="form" [formGroup]="control">
    <ife-title
      [title]="'modules.evcQuote.steps.personalDetails.steps.existingClient.title' | translate"
      data-cy="existing-client-title"
    ></ife-title>

    <div class="flex flex-wrap checkboxPadding justify-center">
      <ife-checkbox
        id="accessBadgeYes"
        data-cy="yes"
        class="w-full sm:w-auto"
        [value]="booleanQuestionValues.yes"
        formControlName="existingClient"
        [image]="'./assets/general/img/yes.svg'"
        [caption]="'general.yes' | translate"
      >
      </ife-checkbox>
      <ife-checkbox
        id="accessBadgeNo"
        data-cy="no"
        class="w-full sm:w-auto"
        [value]="booleanQuestionValues.no"
        formControlName="existingClient"
        [image]="'./assets/general/img/no.svg'"
        [caption]="'general.no' | translate"
      >
      </ife-checkbox>
    </div>

    <div *ngIf="control.get('existingClient').value === booleanQuestionValues.yes" class="form-group max-w-2xl mx-auto">
      <div
        class="form-element input-text"
        [class.errors]="
          !control.get('clientNumber').pristine &&
          control.get('clientNumber').touched &&
          control.get('clientNumber').invalid
        "
      >
        <div class="flex">
          <label for="client-number">
            {{ "modules.evcQuote.steps.personalDetails.steps.existingClient.clientNumber.label" | translate }}
          </label>
          <app-tooltip
            [content]="'modules.evcQuote.steps.personalDetails.steps.existingClient.clientNumber.tooltip' | translate"
          ></app-tooltip>
        </div>
        <input
          id="client-number"
          name="client-number"
          type="text"
          formControlName="clientNumber"
          data-cy="input-client-number"
          autocomplete="off"
          [placeholder]="
            'modules.evcQuote.steps.personalDetails.steps.existingClient.clientNumber.placeholder' | translate
          "
        />
        <div class="message">
          <span
            *ngIf="
              !control.get('clientNumber').pristine &&
              control.get('clientNumber').touched &&
              control.get('clientNumber').invalid
            "
          >
            {{ "modules.evcQuote.steps.personalDetails.steps.contactDetails.errorMessage.clientNumber" | translate }}
          </span>
        </div>
      </div>
    </div>

    <ife-navigation
      [showNext]="control.valid"
      [showPrevious]="true"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
    >
    </ife-navigation>
  </div>
</div>
